import React from 'react'
import styled from '@emotion/styled'
import { Icon, Tabs } from 'antd'
import { PAYG } from 'utils/constants'
import Users from 'views/UserManagement/Users'
import Projects from 'views/UserManagement/Projects'
import { ContentContainer, ErrorBoundary, PageCrumbs } from 'components'
import { useUser } from 'context/user-context'
import ApiKeys from 'views/UserManagement/ApiKeys'
import SubscriptionTransactions from 'views/UserManagement/Transactions'
import AccountCredits from 'views/UserManagement/Credits'

const { TabPane } = Tabs

const Top = styled.div({
  marginBottom: 20
})
const TabsWrapper = styled.div({
  '.ant-tabs-bar': {
    marginBottom: 0
  }
})
function UserManagement() {
  const user = useUser()
  const isPaygAccount = user.account_type === PAYG
  return (
    <ErrorBoundary>
      <Top>
        <PageCrumbs crumbs={[{ name: 'Account Management', icon: 'team' }]} />
      </Top>

      <ContentContainer pad="none">
        <TabsWrapper>
          <Tabs tabPosition="top" defaultActiveKey="users">
            <TabPane
              key="apikeys"
              tab={
                <span>
                  <Icon type="key" />
                  Api Keys
                </span>
              }
            >
              <ApiKeys />
            </TabPane>
            {!isPaygAccount && (
              <TabPane
                key="subscriptionCredits"
                tab={
                  <span>
                    <Icon type="credit-card" />
                    Credits
                  </span>
                }
              >
                <AccountCredits />
              </TabPane>
            )}
            <TabPane
              key="projects"
              tab={
                <span>
                  <Icon type="project" />
                  Projects
                </span>
              }
            >
              <Projects />
            </TabPane>
            {isPaygAccount && (
              <TabPane
                key="subscriptionTransactions"
                tab={
                  <span>
                    <Icon type="credit-card" />
                    Transactions
                  </span>
                }
              >
                <SubscriptionTransactions />
              </TabPane>
            )}
            <TabPane
              key="users"
              tab={
                <span>
                  <Icon type="team" />
                  Users
                </span>
              }
            >
              <Users />
            </TabPane>
          </Tabs>
        </TabsWrapper>
      </ContentContainer>
    </ErrorBoundary>
  )
}

export default UserManagement
